import styled from 'styled-components'
import { queries } from '~/constants/mediaQuery'

const Container = styled.div`
  display: flex;
  padding: 32px;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  border: 1px solid var(--gray-100, #edf2f7);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, #fff 100%),
    url(<path-to-image>) lightgray 50% / cover no-repeat;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
  z-index: 0;

  @media ${queries.less.mdxs} {
    gap: 16px;
  }
`

const Title = styled.span`
  align-self: stretch;
  color: #2f2b3d;
  opacity: 0.9;

  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.4px;
`

const DescriptionAndButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`

const Description = styled.span`
  div {
    align-self: stretch;
    color: var(--gray-600, #4a5568);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;

    span {
      color: #28c76f;
    }
  }
`

const ButtonWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`

const Styles = {
  Container,
  Content,
  Title,
  DescriptionAndButton,
  Description,
  ButtonWrapper,
}
export default Styles
